import React, { useContext } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../theme';

const propTypes = {
  isPressed: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};

const defaultProps = {
  className: '',
  width: 32,
  height: 32,
  style: {}
};

const PressedButton = (props) => {
  const { isPressed, style, className, width, height, onClick } = props;
  const context = useContext(ThemeContext);

  let pressedButton;
  let isTouchDevice = false;
  const theme = useTheme();
  if (theme && theme.pressedButton) {
    pressedButton = theme.pressedButton;
    isTouchDevice = theme.isTouchDevice;
  } else {
    pressedButton = context.theme.pressedButton;
    isTouchDevice = context.theme.isTouchDevice;
  }

  const {
    borderColor,
    textColor,
    background,
    pressedBorderColor,
    pressedTextColor,
    pressedBackground,
    hoverBorderColor,
    hoverBackground,
    hoverTextColor,
    borderRadius
  } = pressedButton;

  const styles = StyleSheet.create({
    pressedBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: `1px solid ${borderColor}`,
      borderRadius,
      color: textColor,
      width: `${width}px`,
      height: `${height}px`,
      pointer: 'cursor',
      background
      // ':hover:not(.active)': {
      //   border: `1px solid ${hoverBorderColor}`,
      //   color: hoverTextColor,
      //   background: hoverBackground
      // }
    },
    activePressedBtn: {
      border: `1px solid ${pressedBorderColor}`,
      background: pressedBackground,
      color: pressedTextColor
    },
    hoverStyles: {
      ':hover:not(.active)': {
        border: `1px solid ${hoverBorderColor}`,
        color: hoverTextColor,
        background: hoverBackground
      }
    }
  });

  return (
    <div
      className={`${isPressed ? 'active' : ''} noselect ${className} ${css(styles.pressedBtn, isPressed && styles.activePressedBtn, !isTouchDevice && styles.hoverStyles)}`}
      style={style}
      onClick={onClick}
    >
      {props.children}
    </div>
  );
};

PressedButton.propTypes = propTypes;
PressedButton.defaultProps = defaultProps;

export { PressedButton };
